var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDrawerHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.65523 1.10893L16.7218 8.33593C17.0573 8.68059 17.2498 9.16093 17.2498 9.65501V17.333C17.2498 18.3441 16.4734 19.1663 15.5191 19.1663H12.6665V10.9163C12.6665 10.4103 12.2567 9.99968 11.7498 9.99968H6.24982C5.7429 9.99968 5.33315 10.4103 5.33315 10.9163V19.1663H2.4814C1.52715 19.1663 0.749817 18.3441 0.749817 17.333V9.65501C0.749817 9.16093 0.942317 8.68059 1.2769 8.33684L8.3444 1.10893C8.68998 0.756009 9.30965 0.756009 9.65523 1.10893ZM10.8333 18.25H7.16667V11.8334H10.8333V18.25Z",
    fill: "#335C75"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrawerHome);
export default __webpack_public_path__ + "static/media/DrawerHome.1e2203cb986ffd09625ce79263af57ca.svg";
export { ForwardRef as ReactComponent };